// routes
// components
import { PATH_AUTH, PATH_CDSS } from '../../routes/paths';
// ----------------------------------------------------------------------

export const adminSidebarConfig = () => [
  {
    subheader:'결과 예측',
    items: [
      {
        title: '저혈압 확률 예측',
        path: PATH_CDSS.hypotension
      }
    ],
  },
  {
    subheader:'관리',
    items: [
      {
        title: '내 정보 관리',
        path: PATH_AUTH.management.myInfo
      },
      {
        title: '권한 관리',
        path: PATH_AUTH.management.authInfo
      },
      {
        title: '컷 오프 관리',
        path: PATH_AUTH.management.cutoff
      },
    ],
  },

];

export const noAuthSidebarConfig = () => [
  {
    subheader:'결과 예측',
    items: [
      {
        title: '저혈압 확률 예측',
        path: PATH_CDSS.hypotension
      }
    ],
  },
  {
    subheader:'관리',
    items: [
      {
        title: '내 정보 관리',
        path: PATH_AUTH.management.myInfo
      },
      
    ],
  },

];

export const authSidebarConfig = () => [
  {
    subheader:'결과 예측',
    items: [
      {
        title: '저혈압 확률 예측',
        path: PATH_CDSS.hypotension
      }
    ],
  },
  {
    subheader:'관리',
    items: [
      {
        title: '내 정보 관리',
        path: PATH_AUTH.management.myInfo
      },
      {
        title: '컷 오프 관리',
        path: PATH_AUTH.management.cutoff
      },
    ],
  },

];

